module.exports = __webpack_public_path__ + "img/6060_1.7e8aebec.png";